module.exports = __webpack_public_path__ + "static/media/camion.f1923933.svg";